<template>
  <div class="row">
    <div class="col-12">
      <p class="bg-error text-warning">{{ error }}</p>
    </div>
    <loading v-model:active="isLoading" />
    <div
      class="col-4 col-lg-4 col-md-4 adjust_height"
      v-for="(item, index) in inventory"
      :key="index"
    >
      <div class="md-card inv-chars">
        <div
          class="inventory_img wood-card-frame position-relative"
          :class="isSelected(item) ? 'selected-img' : ''"
        >
          <a href="#" @click.prevent="addCard(item)">
            <div class="locked-img" v-if="exp(item.value.lock_end)">
              <i class="bi bi-lock-fill"></i>
            </div>
            <VideoBlock
              :link="item.value.templ_id"
              v-if="item.value.schema == 'characters'"
            />
            <VideoBlock :link="item.value.templ_id" v-else />
            <div
              class="animation-bottom fadeIn-bottom"
              v-if="
                item.value.schema == 'characters' &&
                enoughEnergy(item.value.energy)
              "
            >
              <div class="animated-text">
                <p class="position-relative">Level:{{ item.value.level }}</p>
              </div>
            </div>
          </a>
        </div>
        <div
          class="refile-button"
          v-if="
            item.value.schema == 'characters' &&
            !enoughEnergy(item.value.energy)
          "
        >
          <a
            href="JavaScript:void(0)"
            @click="openModal(item)"
            class="position-relative btn btn-outline"
          >
            refill
          </a>
        </div>
        <div class="progress-main">
          <div class="progress-wrapper">
            <div class="progress mb-1" v-if="enoughEnergy(item.value.energy)">
              <div
                v-if="item.value.schema == 'guns'"
                class="progress-bar bg-warning"
                role="progressbar"
                :style="{
                  width: (item.value.energy / 330) * 100 + '%',
                }"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ item.value.energy }}
              </div>
              <div
                v-else
                class="progress-bar bg-success"
                role="progressbar"
                :style="{
                  width: (item.value.energy / 20) * 100 + '%',
                }"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ item.value.energy }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RefillEnergyModal
      v-if="showModal"
      :items="selectedCard"
      v-on:w-modal-hide-click="loadInventory"
    />
  </div>
</template>
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import RefillEnergyModal from "../components/Modal/RefillEnergyModal.vue";
import Loading from "vue-loading-overlay";
import VideoBlock from "../components/VideoBlock.vue";
import { mapGetters } from "vuex";
import ApiService from "../services";
export default {
  name: "Myinventory",
  props: ["mode"],
  components: {
    Loading,
    VideoBlock,
    RefillEnergyModal,
  },
  computed: {
    ...mapGetters(["inventory", "selectedChars","selectedGun"]),
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      selectedCard: {},
      schema: "characters",
      error: "",
      selectedStakeCards: [],
    };
  },
  methods: {
    loadInventory(){
        this.showModal = false;
        this.$emit('reload', []);
    },
    isSelected(item){
      if(item.value.schema=="guns"){
        if(this.selectedGun){
          return this.selectedGun.asset_id == item.key;
        }else{
          return false;
        }
      }else{
        if(this.selectedChars.length){
          return this.selectedChars.findIndex((el) => el.asset_id == item.key) !== -1;
        }else{
          return false;
        }
      }
    },
    openModal(value) {
      this.showModal = true;
      this.selectedCard = value;
    },
    enoughEnergy(energy) {
      if (this.mode == "bankrobbery") {
        if (energy < 8) {
          return false;
        }
      } else if (energy < 4) {
        return false;
      }
      return true;
    },
    exp(lock_end) {
      return ApiService.isExpired(lock_end);
    },
    addCard(item) {
      if (this.exp(item.value.lock_end)) {
        this.error = "Lock item cannot be selected";
        setTimeout(() => {
          this.error = "";
        }, 3000);
      } else if (!this.enoughEnergy(item.value.energy)) {
        this.error = "low energy";
        setTimeout(() => {
          this.error = "";
        }, 3000);
      } else {
        let itemIndex = this.selectedStakeCards.indexOf(item);
        let isGun = item.value.schema == "guns" ? true : false;
        if (itemIndex === -1) {
          if (isGun) {
            this.selectedStakeCards.splice(itemIndex, 1);
            this.$store.commit("rmCard", item);
            this.selectedStakeCards = [item];
            setTimeout(() => {
              this.$store.commit("addCard", item);
            }, 100);
          } else {
            if (this.selectedStakeCards.length < 3) {
              this.selectedStakeCards.push(item);
              this.$store.commit("addCard", item);
            }
          }
        } else {
          itemIndex = this.selectedStakeCards.findIndex(
            (el) => el.key == item.key
          );
          this.selectedStakeCards.splice(itemIndex, 1);
          this.$store.commit("rmCard", item);
        }
      }
    },
  },
};
</script>

<style scoped>
.top_btns {
  z-index: 1;
}

.wood-card-frame:hover .animation-bottom {
  top: 50%;
  left: 50%;
  opacity: 1;
}
.fadeIn-bottom {
  top: 55%;
}
.animation-bottom {
  transform: translate(-50%, -1%);
  padding-left: 0.7em;
  padding-right: 0.7em;
}

.animation-bottom .animated-text {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  height: 85px;
  opacity: 0;
  transition: all 0.4s ease-in-out 0s;
}
.wood-card-frame:hover .animated-text {
  opacity: 1;
}
.md-card {
  margin-bottom: 26px;
  height: 191px;
  width: 120px;
}

.progress-main {
  width: 83%;
  display: block;
  margin: 0 auto;
  position: relative;
}

.progress-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  /* margin: auto; */
  left: 0;
  top: 5px;
  text-align: center;
}
.refile-button {
  width: 70px;
  margin: auto;
}
.progress-wrapper .progress {
  height: 0.8rem !important;
}

.buttons-wrapper {
  width: 70px;
  margin: auto;
}
.btn-outline {
  /* border: 1px solid green; */
  color: #fff;
  padding: 0px 14px;
  background: green;
  font-size: 14px;
  width: 100%;
}
.btn:hover {
  color: #fff !important;
}
.bg-error {
  background: #ff000040;
}
.locked-img {
  color: #fff;
  font-size: 25px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  height: 90%;
  width: 82%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 10;
}
@media (max-width: 768px) {
  .md-card {
    width: 100%;
    margin: 0px auto;
    height: 100%;
    padding: 0;
  }
  .modal-inner {
    margin-top: 0px;
    padding-top: 40px;
  }
  .progress-main {
    bottom: 0px;
    z-index: 9;
    width: 70%;
  }
  .locked-img {
    height: 91%;
    width: 100%;
  }
  .adjust_height{
    height: 240px;
  }
}
</style>
